/*
 * @Description:
 * @Author: luckymiaow
 * @Date: 2022-09-07 17:10:35
 * @LastEditors: luckymiaow
 */

export default async (url: string, imgRef: HTMLImageElement, authorization: string) => {
  if (url == null || imgRef == null) return;
  if (authorization == null) throw new Error('useAuthImg in authorization 不能为空');
  let request = new XMLHttpRequest();
  request.responseType = 'blob';
  request.open('get', url, true);
  request.setRequestHeader('Authorization', authorization);
  request.onreadystatechange = e => {
    if (request.readyState == XMLHttpRequest.DONE && request.status == 200) {
      imgRef.src = URL.createObjectURL(request.response);
      imgRef.onload = () => {
        URL.revokeObjectURL(url);
      };
    }
  };
  request.send(null);
};
